import { API } from "../config/axiosConfig";
import endpoints from "../endpoints/endpoints";

export const userModule = {
  sellerRegister: async (payload) => {
    try {
      const response = await API.post(endpoints.sellerRegistration, payload);
      return {
        success: true,
        data: response.data,
        message: response.data.message || "Seller register successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to register seller",
        error: error.response?.data || error,
      };
    }
  },

  getSellerProfile: async () => {
    try {
      const response = await API.get(endpoints.getSellerProfile);
      return {
        success: true,
        data: response.data,
        message: response.data.message || "Profile fetched successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch profile",
        error: error.response?.data || error,
      };
    }
  },

  getSellerInfo: async () => {
    try {
      const response = await API.get(endpoints.getSellerInfo);
      return {
        success: true,
        data: response.data,
        message: response.data.message || "Seller Info fetched successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch seller info",
        error: error.response?.data || error,
      };
    }
  },
  
  getSellerInfoById: async (sellerId) => {
    try {
      const response = await API.get(`${endpoints.getSellerInfo}?seller_id=${sellerId}`);
      return {
        success: true,
        data: response.data,
        message: response.data.message || "Seller Info fetched successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch seller info",
        error: error.response?.data || error,
      };
    }
  },

  /* A seller's reviews, for the store page's rating panel. Paged, because a
     busy seller's whole history is not what opening a panel should cost. */
  getSellerReviews: async (sellerId, { index = 0, offset = 20 } = {}) => {
    try {
      const response = await API.get(endpoints.getSellerReviews, {
        params: { seller_id: sellerId, index, offset },
      });
      return {
        success: true,
        data: response.data?.data || [],
        total: response.data?.total || 0,
        message: response.data?.message || "Reviews fetched successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch reviews",
        error: error.response?.data || error,
      };
    }
  },

  getWallet: async () => {
    try {
      const response = await API.get(endpoints.getWallet);
      return {
        success: true,
        data: response.data,
        message: response.data.message || "Wallet fetched successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch wallet",
        error: error.response?.data || error,
      };
    }
  },

  getDeliveryInfo: async () => {
    try {
      const response = await API.get(endpoints.getDeliveryInfo);
      return {
        success: true,
        data: response.data,
        message: response.data.message || "Delivery info fetched successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch delivery info",
        error: error.response?.data || error,
      };
    }
  },

  updateDeliveryInfo: async (payload) => {
    try {
      const response = await API.put(endpoints.updateDeliveryInfo, payload);
      return {
        success: true,
        data: response.data,
        message: response.data.message || "Delivery info updated successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to update delivery info",
        error: error.response?.data || error,
      };
    }
  },

  // Logout (requires authentication)
  logout: async () => {
    try {
      const response = await API.post(endpoints.logout);
      return {
        success: true,
        data: response.data,
        message: "Logged out successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message || error.message || "Logout failed",
        error: error.response?.data || error,
      };
    }
  },

  updateSellerProfile: async (formData) => {
    try {
      const response = await API.put(endpoints.updateSellerProfile, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return {
        success: true,
        data: response.data,
        message: response.data.message || "Profile updated successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to update profile",
        error: error.response?.data || error,
      };
    }
  },

   updateBuyerProfile: async (formData) => {
    try {
      const response = await API.put(endpoints.updateBuyerProfile, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return {
        success: true,
        data: response.data,
        message: response.data.message || "Profile updated successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to update profile",
        error: error.response?.data || error,
      };
    }
  },

  updateSellerInfo: async (formData) => {
    try {
      const response = await API.put(endpoints.updateSellerInfo, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return {
        success: true,
        data: response.data,
        message: response.data.message || "Seller info updated successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to update seller info",
        error: error.response?.data || error,
      };
    }
  },
};
